import { createTaskMutations } from './create';
import { updateTaskMutations } from './update';
import { otherTaskMutations } from './other';

export const mutationsTasks = {
  ...createTaskMutations,
  ...updateTaskMutations,
  ...otherTaskMutations
};
